var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70473 24.8573C12.1152 24.8573 14.0693 23.1316 14.0693 20.4928V0.916992H19.3036C19.01 4.48707 22.559 7.93568 26.4729 7.85681V12.7788C23.1257 12.7788 20.2794 11.3635 19.2887 10.578V20.4928C19.2887 24.8573 15.8552 29.8066 9.70473 29.8066C3.55427 29.8066 0.195679 24.8573 0.195679 20.4928C0.195679 14.3326 6.71468 10.76 11.0323 11.6332V16.6465C10.8151 16.5697 10.255 16.4561 9.7779 16.4561C7.3474 16.3665 5.34019 18.3378 5.34019 20.4928C5.34019 22.9032 7.29426 24.8573 9.70473 24.8573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.17317dbeba1caf579c5734173b94c5b4.svg";
export { ForwardRef as ReactComponent };